import { useQuery } from 'react-query';

export default function useCurrentLiveStream() {
  const { data } = useQuery<any>('currentLiveStream', () => null, { enabled: false });
  return { currentLiveStream: data };
}
